import { render, staticRenderFns } from "./SnackbarWrapper.vue?vue&type=template&id=2e6259b2&scoped=true&"
import script from "./SnackbarWrapper.vue?vue&type=script&lang=ts&"
export * from "./SnackbarWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./SnackbarWrapper.vue?vue&type=style&index=0&id=2e6259b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6259b2",
  null
  
)

export default component.exports